import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { DOWNLOAD_LINK_WITH_ICON_CONVERTER_TOKEN, DownloadLinkWithIconConverter } from './download-link-with-icon.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        downloadLinkWithIconFeature: {
          module: () => import('./download-link-with-icon.module').then((m) => m.DownloadLinkWithIconModule),
          cmsComponents: ['downloadlinkwithicon']
        },
      }
    }),
    {
      provide: DOWNLOAD_LINK_WITH_ICON_CONVERTER_TOKEN,
      useExisting: DownloadLinkWithIconConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        downloadlinkwithicon: DOWNLOAD_LINK_WITH_ICON_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class DownloadLinkWithIconFeatureModule {}
